import { z } from 'zod';
import superjson from 'superjson';
import { PomlFormat } from './import_POST.schema';

export const schema = z.object({
  id: z.string().min(1),
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  poml: PomlFormat;
};

export const getExportPersona = async (
  input: InputType,
  init?: RequestInit,
): Promise<OutputType> => {
  const params = new URLSearchParams({ id: input.id });
  const result = await fetch(`/_api/personas/export?${params}`, {
    method: 'GET',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });

  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }

  return superjson.parse<OutputType>(await result.text());
};
